<mat-progress-bar *ngIf="!relatics" mode="indeterminate"></mat-progress-bar>
<form data-cy="complaint-contact-modal__form-form" #form="ngForm" (ngSubmit)="updateComplaint()" *ngIf="relatics">
    <div data-cy="complaint-contact-modal__page" mat-dialog-title>
        <h4 class="mb-10 ml-10 inline-block">Contactgegevens melding {{ data.complaint.id }}</h4>
        <button data-cy="complaint-contact-modal__close-btn" type="button" class="close" (click)="close()">
    <span aria-hidden="true"><mat-icon>close</mat-icon></span>
    <span class="sr-only">Close</span>
    </button>
    </div>
    <!-- modal body -->
    <div *ngIf="type ==='complaints'">
        <div class="modal-body" *transloco="let t">
            <mat-form-field class="full-width mt-15" [matTooltip]="relatics.complainant_name ? t('settings.relatic.disable_field') : null">
              <mat-label>Naam</mat-label>
                <input data-cy="complaint-contact-modal__complainant-name-input" matInput  name="name" [(ngModel)]="complaint.complainant_name" [disableControl]="relatics.complainant_name">
            </mat-form-field>
            <mat-form-field class="full-width" [matTooltip]="relatics.complainant_name ? t('settings.relatic.disable_field') : null" [class.title-field-invalid]="emailField.invalid && (form.submitted || emailField.touched)">
              <mat-label>Email</mat-label>
                <input data-cy="complaint-contact-modal__complainant-email-input" #emailField="ngModel" matInput type="email" name="email" [(ngModel)]="complaint.complainant_email" [disableControl]="relatics.complainant_email" email>
            </mat-form-field>
            <div [matTooltip]="relatics.complainant_phone ? t('settings.relatic.disable_field') : null">
                <mat-form-field class="full-width phone" style="width: 90%;" [class.title-field-invalid]="phoneNumber.invalid && (form.submitted || phoneNumber.touched)">
                    <mat-label>Telefoonnummer</mat-label>
                    <ngx-mat-intl-tel-input
                        #phoneNumber="ngModel"
                        name="phone_number"
                        [(ngModel)]="complaint.complainant_phone"
                        [preferredCountries]="['nl']"
                        [enablePlaceholder]="true"
                        [enableSearch]="true"
                        [disableControl]="relatics.complainant_phone"
                        matInput
                        class="custom-tel-input"
                        autocomplete="off"
                    ></ngx-mat-intl-tel-input>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div *ngIf="type ==='decisions'">
        <div class="modal-body" *transloco="let t">
            <mat-form-field class="full-width mt-15" [matTooltip]="relatics.manual_contact_name ? t('settings.relatic.disable_field') : null">
              <mat-label>Naam</mat-label>
                <input data-cy="complaint-contact-modal__manual-contact-name-input" matInput  name="name" [(ngModel)]="complaint.manual_contact_name" [disableControl]="relatics.manual_contact_name">
            </mat-form-field>
            <mat-form-field class="full-width" [matTooltip]="relatics.complainant_name ? t('settings.relatic.disable_field') : null" [class.title-field-invalid]="emailFieldManual.invalid && (form.submitted || emailFieldManual.touched)">
              <mat-label>Email</mat-label>
                <input data-cy="complaint-contact-modal__manual-contact-email-input" #emailFieldManual="ngModel" matInput type="email" placeholder="Email" name="email_manual" [(ngModel)]="complaint.manual_contact_email" [disableControl]="relatics.complainant_email" email>
            </mat-form-field>
            <div [matTooltip]="relatics.complainant_phone ? t('settings.relatic.disable_field') : null">
                <mat-form-field class="full-width phone" style="width: 90%;" [class.title-field-invalid]="phoneNumberManual.invalid && (form.submitted || phoneNumberManual.touched)">
                    <mat-label>Telefoonnummer</mat-label>
                    <ngx-mat-intl-tel-input
                        #phoneNumberManual="ngModel"
                        name="phone_number_manual"
                        [(ngModel)]="complaint.manual_contact_telephone"
                        [preferredCountries]="['nl']"
                        [enablePlaceholder]="true"
                        [enableSearch]="true"
                        [disableControl]="relatics.complainant_phone"
                        matInput
                        class="custom-tel-input"
                        autocomplete="off"
                    ></ngx-mat-intl-tel-input>
                </mat-form-field>
            </div>
        </div>
    </div>
    <!--end of modal body -->
    <div class="modal-footer" *transloco="let t">
        <button data-cy="complaint-contact-modal__btn" type="button" class="btn btn-secondary" (click)="close()">{{ t('close') | capitaliz }}</button>
        <button data-cy="complaint-contact-modal__btn-2" type="submit" class="btn d-btn-dialog mdl-button mdl-js-button mdl-button--raised" [disabled]="form.invalid">
    {{ t('save') | capitaliz }}
    </button>
    </div>
    <!--end of modal footer -->

</form>
